// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/Status/Status.css
// module id = 2003
// module chunks = 0